import { publicClient } from "../client/public-client";

// User agent string
function getUserAgent() {
  return navigator.userAgent;
}

function getOrCreateDeviceId() {
  let id = localStorage.getItem("rehema_device_id");
  if (!id) {
    if (window.crypto?.randomUUID) {
      id = crypto.randomUUID();
    } else {
      id = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    }
    localStorage.setItem("rehema_device_id", id);
    document.cookie = `rehema_device_id=${id}; Max-Age=${
      60 * 60 * 24 * 365 * 5
    }; Path=/; SameSite=Lax`;
  }
  return id;
}

export const login = async (username, password) => {
  try {
    const response = await publicClient.post("/users/login", {
      username,
      password,
      userAgent: getUserAgent(),
      platform: "Web",
      deviceId: getOrCreateDeviceId(),
    });
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const setNewAuthPassword = async (id, currentPassword, newPassword) => {
  try {
    const response = await publicClient.patch(`/users/updatepassword/${id}`, {
      password: newPassword,
      current_password: currentPassword,
    });
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const sendIdentifier = async (email) => {
  try {
    const response = await publicClient.post(`/users/password/otp/request`, {
      identifier: email,
    });
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const resendIdentifier = async (email) => {
  try {
    const response = await publicClient.post(`/users/password/otp/resend`, {
      identifier: email,
    });
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const verifyResetPassword = async (email, otp) => {
  try {
    const response = await publicClient.post(`/users/password/otp/verify`, {
      identifier: email,
      otp,
    });
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const resetNewPassword = async (email, newPassword, confirmPassword) => {
  try {
    const response = await publicClient.post(`/users/password/otp/reset`, {
      identifier: email,
      newPassword: newPassword,
      confirmPassword: confirmPassword,
    });
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const sendUserOtp = async (userId) => {
  try {
    const response = await publicClient.post("/otp/user", {
      userId,
      isEmail: false,
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const verifyUserOtp = async (otp, email, userId) => {
  try {
    const response = await publicClient.post("/users/otp/verify-login", {
      code: otp,
      isEmail: false,
      email,
      userId,
      deviceId: getOrCreateDeviceId(),
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
